module.exports = __webpack_public_path__ + "img/logo_mark.14c6bc06.png";